export default __webpack_public_path__ + "static/media/cp_geo_ba.43bcce38.svg";